import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import { selectData } from '../../../utils/select-data';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Assigns Vehicle Groups to a given Place Set
 * @param setId ID of the Place Set being assigned to
 * @param assignmentVehicleGroupIds IDs of Vehicle Groups being assigned
 * @param unassignmentVehicleGroupIds IDs of Vehicle Groups being unassigned
 * @returns Array of IDs
 */
export function postPlaceSetsVehicleGroupsCombinedAssignment(
  this: unknown,
  setId: number,
  assignmentVehicleGroupIds: number[],
  unassignmentVehicleGroupIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .placeSetsVehicleGroupsCombinedAssignmentUrl(setId),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            assignmentVehicleGroupIds,
            unassignmentVehicleGroupIds,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.object({
          assigned: z.array(z.number()),
          unassigned: z.array(z.number()),
        }),
      })
    )
  );
}
